import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExposure1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"exposure-1, plus-minus"} maskId="square-filled-radius-0-stroke-1-IconExposure1"><path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.5 6V9H15.5V10H12.5V13H11.5V10H8.5V9H11.5V6H12.5ZM8.5 16V17H15.5V16H8.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconExposure1;
